import { BaseTextMergeContainerEditor } from "./BaseTextMergeContainerEditor";
import React from "react";
import { TextEditorRegistration } from "../../Utilities/RegisterTextEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { CodeIcon } from "../../../CommonUI/Icon/CodeIcon";
import { CodeElement } from "../../../rule-engine-core/TextMerge/Elements/Text/CodeElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";

export class TextMergeCodeEditor extends BaseTextMergeContainerEditor<CodeElement> {
    renderContent(editContext: TextMergeEditContext, styles: object): React.ReactNode {
        return (
            <p>
                <code style={styles}>
                    {this.editorData?.elements.map((e) => {
                        let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                        return (
                            <ObserveState
                                listenTo={e}
                                control={() => {
                                    return editor?.renderDisplay(e, editContext);
                                }}
                            />
                        );
                    })}
                </code>
            </p>
        );
    }

    getIcon(): JSX.Element {
        return <CodeIcon />;
    }
}
